export default () => ({
  myMakes: [],
  competitorMakes: [],
  makes: null,
  loading: false
})
